import type { ReactNode } from 'react';

/**
 * 모든 layout · 자체 chrome 페이지의 공통 outer shell — chrome SSOT.
 *
 * - `min-h-dvh` + `bg-background`
 * - safe-area inset(top/bottom) + 수직 여백 `calc(env + 2rem)`
 * - 뷰포트 horizontal gutter `px-6`
 * - flex column (콘텐츠 정렬은 자식 책임)
 *
 * 콘텐츠 `max-w` · 내부 spacing · 정렬은 호출처 담당.
 */
export function ScreenShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col bg-background px-6 pt-[calc(env(safe-area-inset-top)+2rem)] pb-[calc(env(safe-area-inset-bottom)+2rem)]">
      {children}
    </div>
  );
}
